import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'cartItemFilter'
})
export class CartItemFilterPipe implements PipeTransform {
    transform(items: any[], filterId: number): any[] {
        if (!items) {
            return [];
        }

        return items.filter(item => {
            return item.eventPerformerExperienceId === filterId;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/_pipes/cart-item-filter.pipe.ts